package pl.decks.chartjs.radar.options

import pl.decks.chartjs.interaction.EasingFunction
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption

data class RadarAnimationOptions(
    val duration: Int = 1000,
    val easing: EasingFunction = EasingFunction.EaseInOutQuart,
    val delay: Int? = null,
    val loop: Boolean? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.duration = duration.asDynamic()
        this.easing = easing.toChartJs()
        if (delay != null) this.delay = delay.asDynamic()
        if (loop != null) this.loop = loop.asDynamic()
    }
}
